/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as controlAccessControlV1 from "./keyapis_access_control_access_control_v1.pb"

/**
 * Сервис реализует функционал управления квартирограммами.
 * В настоящий момент Квартирограмма является корневым агрегатом для домов, принадлежит управляющей компании.
 * На транспортном уровне определяет связи между устройствами и квартирами
 */

/**
 * Сервис управления квартирограммами
 */
export class FlatgrammServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод получения облегченной квартирограммы.
   * Для пользователей типов owner, employee возвращаются только квартирограммы привязанные к компании пользователя.
   * Для пользователей типов owner, employee: в результат попадают только квартирограммы, привязанные к компании пользователя по любому из типов связи FlatgrammCompanyRelation.Type.
   * Метод доступен для: admin, manager, service, bti, ltp_first, owner, employee
   */
  GetFlatgramm = (req: GetFlatgrammRequestDto, init?: RequestInit): Promise<GetFlatgrammResponseDto> => {
    return fm.request<GetFlatgrammRequestDto, GetFlatgrammResponseDto>(`${this.host}/access_control/api/v1/flatgramm/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка облегченных квартирограмм.
   * Для пользователей типов owner, employee: в результат фильтрации попадают только квартирограммы компании пользователя.
   * Для пользователей типов owner, employee: если filter.company_ids непустое и не совпадает с COMPANY_ID пользователя, метод вернет PERMISSION_DENIED = 7 (403 Forbidden).
   * Для пользователей типов owner, employee: если filter.company_ids пустое, то фильтрация по COMPANY_ID пользователя.
   * Метод доступен для: admin, manager, service, bti, ltp_first, owner, employee
   */
  GetFlatgrammList = (req?: GetFlatgrammListRequestDto, init?: RequestInit): Promise<GetFlatgrammListResponseDto[]> => {
    return fm.list<GetFlatgrammListRequestDto, GetFlatgrammListResponseDto>(`${this.host}/access_control/api/v1/flatgramm/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества квартирограмм.
   * Для пользователей типов owner, employee: в результат фильтрации попадают только квартирограммы компании пользователя.
   * Для пользователей типов owner, employee: если filter.company_ids непустое и не совпадает с COMPANY_ID пользователя, метод вернет PERMISSION_DENIED = 7 (403 Forbidden).
   * Для пользователей типов owner, employee: если filter.company_ids пустое, то фильтрация по COMPANY_ID пользователя.
   * Метод доступен для: admin, manager, service, bti, ltp_first, owner, employee
   */
  GetFlatgrammCount = (req?: GetFlatgrammCountRequestDto, init?: RequestInit): Promise<GetFlatgrammCountResponseDto> => {
    return fm.request<GetFlatgrammCountRequestDto, GetFlatgrammCountResponseDto>(`${this.host}/access_control/api/v1/flatgramm/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка связей квартирограмм и домофонной компании.
   * Метод доступен для: admin, service, seller
   * @deprecated
   */
  GetFlatgrammDcCompanyList = (req?: GetFlatgrammDcCompanyListRequestDto, init?: RequestInit): Promise<GetFlatgrammDcCompanyListResponseDto[]> => {
    return fm.list<GetFlatgrammDcCompanyListRequestDto, GetFlatgrammDcCompanyListResponseDto>(`${this.host}/access_control/api/v1/flatgramm/dc_company/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения списка связей квартирограмм и компаний.
   * Метод доступен для: admin, service, seller
   */
  GetFlatgrammCompanyRelationList = (req?: GetFlatgrammCompanyRelationListRequestDto, init?: RequestInit): Promise<GetFlatgrammCompanyRelationListResponseDto[]> => {
    return fm.list<GetFlatgrammCompanyRelationListRequestDto, GetFlatgrammCompanyRelationListResponseDto>(`${this.host}/access_control/api/v1/flatgramm/company_relation/list${fm.buildQuery(req)}`, {...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }
  /**
   * Метод получения количества связей квартирограмм и домофонной компании.
   * Метод доступен для: admin, service, seller
   * @deprecated
   */
  GetFlatgrammDcCompanyCount = (req?: GetFlatgrammDcCompanyCountRequestDto, init?: RequestInit): Promise<GetFlatgrammDcCompanyCountResponseDto> => {
    return fm.request<GetFlatgrammDcCompanyCountRequestDto, GetFlatgrammDcCompanyCountResponseDto>(`${this.host}/access_control/api/v1/flatgramm/dc_company/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения количества связей квартирограмм и компаний.
   * Метод доступен для: admin, service, seller
   */
  GetFlatgrammCompanyRelationCount = (req?: GetFlatgrammCompanyRelationCountRequestDto, init?: RequestInit): Promise<GetFlatgrammCompanyRelationCountResponseDto> => {
    return fm.request<GetFlatgrammCompanyRelationCountRequestDto, GetFlatgrammCompanyRelationCountResponseDto>(`${this.host}/access_control/api/v1/flatgramm/company_relation/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения связей квартирограмм и домофонной компании.
   * Поддерживает только создание.
   * Метод доступен для: admin, service, seller
   * @deprecated
   */
  PutFlatgrammDcCompanyAttach = (req: PutFlatgrammDcCompanyAttachRequestDto, init?: RequestInit): Promise<PutFlatgrammDcCompanyAttachResponseDto> => {
    return fm.request<PutFlatgrammDcCompanyAttachRequestDto, PutFlatgrammDcCompanyAttachResponseDto>(`${this.host}/access_control/api/v1/flatgramm/${encodeURIComponent(req.dcCompanyFlatgramm.flatgrammId)}/dc_company/${encodeURIComponent(req.dcCompanyFlatgramm.companyId)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод сохранения связей квартирограммы и компании.
   * Поддерживает только создание.
   * Метод доступен для: admin, service, seller
   */
  PutFlatgrammCompanyRelationAttach = (req: PutFlatgrammCompanyRelationAttachRequestDto, init?: RequestInit): Promise<PutFlatgrammCompanyRelationAttachResponseDto> => {
    return fm.request<PutFlatgrammCompanyRelationAttachRequestDto, PutFlatgrammCompanyRelationAttachResponseDto>(`${this.host}/access_control/api/v1/flatgramm/${encodeURIComponent(req.flatgrammCompanyRelation.flatgrammId)}/company_relation/${encodeURIComponent(req.flatgrammCompanyRelation.companyId)}/attach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления связей квартирограмм и домофонной компании.
   * Метод доступен для: admin, service, seller
   * @deprecated
   */
  PutFlatgrammDcCompanyDetach = (req: PutFlatgrammDcCompanyDetachRequestDto, init?: RequestInit): Promise<PutFlatgrammDcCompanyDetachResponseDto> => {
    return fm.request<PutFlatgrammDcCompanyDetachRequestDto, PutFlatgrammDcCompanyDetachResponseDto>(`${this.host}/access_control/api/v1/flatgramm/${encodeURIComponent(req.dcCompanyFlatgramm.flatgrammId)}/dc_company/${encodeURIComponent(req.dcCompanyFlatgramm.companyId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления связей квартирограммы и компании.
   * Метод доступен для: admin, service, seller
   */
  PutFlatgrammCompanyRelationDetach = (req: PutFlatgrammCompanyRelationDetachRequestDto, init?: RequestInit): Promise<PutFlatgrammCompanyRelationDetachResponseDto> => {
    return fm.request<PutFlatgrammCompanyRelationDetachRequestDto, PutFlatgrammCompanyRelationDetachResponseDto>(`${this.host}/access_control/api/v1/flatgramm/${encodeURIComponent(req.flatgrammCompanyRelation.flatgrammId)}/company_relation/${encodeURIComponent(req.flatgrammCompanyRelation.companyId)}/detach`, { ...init, method: "PUT", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Справочник типов направлений сортировки
 */
export enum DcCompanyFlatgrammPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type DcCompanyFlatgrammPagingDirectionTypeResponseEnum = keyof typeof DcCompanyFlatgrammPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type DcCompanyFlatgrammPagingDirectionTypeRequestEnum = Exclude<DcCompanyFlatgrammPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов сортировки
 */
export enum DcCompanyFlatgrammPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По Идентификатору домофонной компании
   */
  COMPANY_ID = "COMPANY_ID",
  /**
   * По Идентификатору квартирограммы
   */
  FLATGRAMM_ID = "FLATGRAMM_ID",
}
/**
 * Справочник типов сортировки
 */
export type DcCompanyFlatgrammPagingOrderByTypeResponseEnum = keyof typeof DcCompanyFlatgrammPagingOrderByType
/**
 * Справочник типов сортировки
 */
export type DcCompanyFlatgrammPagingOrderByTypeRequestEnum = Exclude<DcCompanyFlatgrammPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Тип связи компании и квартирограммы.
 * По умолчанию OWNER.
 */
export enum FlatgrammCompanyRelationType {
  /**
   * Значение не указано
   */
  TYPE_UNKNOWN = "TYPE_UNKNOWN",
  /**
   * Управляющая компания владеет квартирограммой
   */
  MANAGEMENT = "MANAGEMENT",
  /**
   * Домофонная компания обслуживает квартирограмму
   */
  DEVICE_SERVICE = "DEVICE_SERVICE",
}
/**
 * Тип связи компании и квартирограммы.
 * По умолчанию OWNER.
 */
export type FlatgrammCompanyRelationTypeResponseEnum = keyof typeof FlatgrammCompanyRelationType
/**
 * Тип связи компании и квартирограммы.
 * По умолчанию OWNER.
 */
export type FlatgrammCompanyRelationTypeRequestEnum = Exclude<FlatgrammCompanyRelationTypeResponseEnum, "TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки
 */
export enum FlatgrammCompanyRelationPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки
 */
export type FlatgrammCompanyRelationPagingDirectionTypeResponseEnum = keyof typeof FlatgrammCompanyRelationPagingDirectionType
/**
 * Справочник типов направлений сортировки
 */
export type FlatgrammCompanyRelationPagingDirectionTypeRequestEnum = Exclude<FlatgrammCompanyRelationPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов сортировки
 */
export enum FlatgrammCompanyRelationPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По Идентификатору компании
   */
  COMPANY_ID = "COMPANY_ID",
  /**
   * По Идентификатору квартирограммы
   */
  FLATGRAMM_ID = "FLATGRAMM_ID",
}
/**
 * Справочник типов сортировки
 */
export type FlatgrammCompanyRelationPagingOrderByTypeResponseEnum = keyof typeof FlatgrammCompanyRelationPagingOrderByType
/**
 * Справочник типов сортировки
 */
export type FlatgrammCompanyRelationPagingOrderByTypeRequestEnum = Exclude<FlatgrammCompanyRelationPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Справочник типов направлений сортировки.
 */
export enum FlatgrammPagingDirectionType {
  /**
   * Значение не указано
   */
  DIRECTION_TYPE_UNKNOWN = "DIRECTION_TYPE_UNKNOWN",
  /**
   * От большего к меньшему
   */
  DESC = "DESC",
  /**
   * От меньшего к большему
   */
  ASC = "ASC",
}
/**
 * Справочник типов направлений сортировки.
 */
export type FlatgrammPagingDirectionTypeResponseEnum = keyof typeof FlatgrammPagingDirectionType
/**
 * Справочник типов направлений сортировки.
 */
export type FlatgrammPagingDirectionTypeRequestEnum = Exclude<FlatgrammPagingDirectionTypeResponseEnum, "DIRECTION_TYPE_UNKNOWN">;

/**
 * Справочник типов значений сортировки.
 */
export enum FlatgrammPagingOrderByType {
  /**
   * Значение не указано
   */
  ORDER_BY_TYPE_UNKNOWN = "ORDER_BY_TYPE_UNKNOWN",
  /**
   * По идентификатору
   */
  ID = "ID",
  /**
   * По времени создания
   */
  CREATED_AT = "CREATED_AT",
  /**
   * По времени изменения
   */
  CHANGED_AT = "CHANGED_AT",
  /**
   * По рангу для поиска по тексту.
   * Применяется когда передано поле для поиска по тексту.
   * В случае если текстовое поле не передано, применяется значение по умолчанию
   */
  RANK = "RANK",
}
/**
 * Справочник типов значений сортировки.
 */
export type FlatgrammPagingOrderByTypeResponseEnum = keyof typeof FlatgrammPagingOrderByType
/**
 * Справочник типов значений сортировки.
 */
export type FlatgrammPagingOrderByTypeRequestEnum = Exclude<FlatgrammPagingOrderByTypeResponseEnum, "ORDER_BY_TYPE_UNKNOWN">;

/**
 * Связка квартирограммы и домофонной компании.
 * Задает область ресурсов (resource scope), доступную пользователю.
 * Используется для контроля доступа к квартирограмме
 * @deprecated
 */
export type DcCompanyFlatgrammRequestDto = {
  /**
   * Идентификатор домофонной компании.
   * # Диапазон: 0..2147483647
   */
  companyId: number
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 0..2147483647
   */
  flatgrammId: number
}
/**
 * Связка квартирограммы и домофонной компании.
 * Задает область ресурсов (resource scope), доступную пользователю.
 * Используется для контроля доступа к квартирограмме
 * @deprecated
 */
export type DcCompanyFlatgrammResponseDto = {
  /**
   * Идентификатор домофонной компании.
   * # Диапазон: 0..2147483647
   */
  companyId: number
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 0..2147483647
   */
  flatgrammId: number
}
/**
 * Фильтр для запроса связей квартирограммы и домофонной компании.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 * @deprecated
 */
export type DcCompanyFlatgrammFilterRequestDto = {
  /**
   * По Идентификатору домофонной компании
   */
  companyIds?: number[]
  /**
   * По Идентификатору квартирограммы
   */
  flatgrammIds?: number[]
}
/**
 * Фильтр для запроса связей квартирограммы и домофонной компании.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 * @deprecated
 */
export type DcCompanyFlatgrammFilterResponseDto = {
  /**
   * По Идентификатору домофонной компании
   */
  companyIds: number[]
  /**
   * По Идентификатору квартирограммы
   */
  flatgrammIds: number[]
}
/**
 * Пагинация квартирограмм и домофонной компании
 * @deprecated
 */
export type DcCompanyFlatgrammPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: COMPANY_ID
   */
  orderByType?: DcCompanyFlatgrammPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: DcCompanyFlatgrammPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация квартирограмм и домофонной компании
 * @deprecated
 */
export type DcCompanyFlatgrammPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: COMPANY_ID
   */
  orderByType: DcCompanyFlatgrammPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: DcCompanyFlatgrammPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Облегченная квартирограмма
 */
export type FlatgrammRequestDto = {
  /**
   * Идентификатор
   */
  id?: number
  /**
   * Наименование
   */
  title: string
  /**
   * Идентификатор компании - владельца
   */
  companyId?: number
}
/**
 * Облегченная квартирограмма
 */
export type FlatgrammResponseDto = {
  /**
   * Идентификатор
   */
  id: number
  /**
   * Наименование
   */
  title: string
  /**
   * Идентификатор компании - владельца
   */
  companyId: number
  /**
   * Дата и время создания.
   * # Тип: DateTime
   */
  readonly createdAt: string
  /**
   * Дата последнего изменения.
   * Заполняется и обновляется сервером.
   * Заполняется при создании и изменении.
   * Является версией объекта.
   * # Тип: DateTime
   */
  readonly changedAt: string
}
/**
 * Связка квартирограммы и компании.
 * Задает область ресурсов (resource scope), доступную пользователю.
 * Используется для контроля доступа к квартирограмме
 */
export type FlatgrammCompanyRelationRequestDto = {
  /**
   * Идентификатор компании.
   * # Диапазон: 1..2147483647
   */
  companyId: number
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 1..2147483647
   */
  flatgrammId: number
  /**
   * Тип связи компании и квартирограммы
   */
  type: FlatgrammCompanyRelationTypeRequestEnum
}
/**
 * Связка квартирограммы и компании.
 * Задает область ресурсов (resource scope), доступную пользователю.
 * Используется для контроля доступа к квартирограмме
 */
export type FlatgrammCompanyRelationResponseDto = {
  /**
   * Идентификатор компании.
   * # Диапазон: 1..2147483647
   */
  companyId: number
  /**
   * Идентификатор квартирограммы.
   * # Диапазон: 1..2147483647
   */
  flatgrammId: number
  /**
   * Тип связи компании и квартирограммы
   */
  type: FlatgrammCompanyRelationTypeResponseEnum
}
/**
 * Фильтр для запроса связей квартирограммы и компании.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type FlatgrammCompanyRelationFilterRequestDto = {
  /**
   * По Идентификатору квартирограммы
   */
  flatgrammIds?: number[]
  /**
   * По Идентификатору компании
   */
  companyIds?: number[]
  /**
   * Тип назначения компании для квартирограммы
   */
  flatgrammCompanyRelationTypes?: FlatgrammCompanyRelationTypeResponseEnum[]
}
/**
 * Фильтр для запроса связей квартирограммы и компании.
 * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
 * При передаче нескольких разных параметров фильтра они работают в выборке через И
 */
export type FlatgrammCompanyRelationFilterResponseDto = {
  /**
   * По Идентификатору квартирограммы
   */
  flatgrammIds: number[]
  /**
   * По Идентификатору компании
   */
  companyIds: number[]
  /**
   * Тип назначения компании для квартирограммы
   */
  flatgrammCompanyRelationTypes: FlatgrammCompanyRelationTypeResponseEnum[]
}
/**
 * Пагинация квартирограмм и компаний
 */
export type FlatgrammCompanyRelationPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: COMPANY_ID
   */
  orderByType?: FlatgrammCompanyRelationPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType?: FlatgrammCompanyRelationPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit?: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset?: number
}
/**
 * Пагинация квартирограмм и компаний
 */
export type FlatgrammCompanyRelationPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * По умолчанию: COMPANY_ID
   */
  orderByType: FlatgrammCompanyRelationPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * По умолчанию: DESC
   */
  directionType: FlatgrammCompanyRelationPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Минимальное значение: 1.
   * Максимальное значение: 100.
   * По умолчанию: 20.
   * Если значение 0 (не передано), то выставляем значение по умолчанию
   */
  limit: number
  /**
   * Сдвиг.
   * По умолчанию: 0
   */
  offset: number
}
/**
 * Фильтр квартирограмм
 */
export type FlatgrammFilterRequestDto = {
  /**
   * По идентификаторам компаний.
   * Фильтрация среди компаний, тип связи компании и КВГ определяется по полю company_relation_types.
   * Если company_relation_types не передан, то учитываются все значения типа FlatgrammCompanyRelation.Type
   */
  companyIds?: number[]
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование
   */
  text?: string
  /**
   * По идентификаторам компаний.
   * Фильтрация среди компаний, привязанных как домофонные компании
   * @deprecated
   */
  dcCompanyIds?: number[]
  /**
   * По типу связи квартирограмм и компаний
   */
  flatgrammCompanyRelationTypes?: FlatgrammCompanyRelationTypeResponseEnum[]
}
/**
 * Фильтр квартирограмм
 */
export type FlatgrammFilterResponseDto = {
  /**
   * По идентификаторам компаний.
   * Фильтрация среди компаний, тип связи компании и КВГ определяется по полю company_relation_types.
   * Если company_relation_types не передан, то учитываются все значения типа FlatgrammCompanyRelation.Type
   */
  companyIds: number[]
  /**
   * Поиск по тексту.
   * Если значение не передано то поиск по нему не производится.
   * # Диапазон: 3..64.
   * # Поиск производится по полям:
   * # - Наименование
   */
  text: string
  /**
   * По идентификаторам компаний.
   * Фильтрация среди компаний, привязанных как домофонные компании
   * @deprecated
   */
  dcCompanyIds: number[]
  /**
   * По типу связи квартирограмм и компаний
   */
  flatgrammCompanyRelationTypes: FlatgrammCompanyRelationTypeResponseEnum[]
}
/**
 * Постраничный вывод
 */
export type FlatgrammPagingRequestDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType?: FlatgrammPagingOrderByTypeRequestEnum | "ORDER_BY_TYPE_UNKNOWN"
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType?: FlatgrammPagingDirectionTypeRequestEnum | "DIRECTION_TYPE_UNKNOWN"
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type FlatgrammPagingResponseDto = {
  /**
   * Тип значения сортировки.
   * Если значение не передано, то будет взято значение по умолчанию.
   * # По умолчанию: CHANGED_AT
   */
  orderByType: FlatgrammPagingOrderByTypeResponseEnum
  /**
   * Тип направления сортировки.
   * # По умолчанию: DESC
   */
  directionType: FlatgrammPagingDirectionTypeResponseEnum
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос получения количества связей квартирограмм и компаний
 */
export type GetFlatgrammCompanyRelationCountRequestDto = {
  /**
   * Фильтр связей квартирограмм и компании
   */
  filter?: FlatgrammCompanyRelationFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества связей квартирограмм и компаний
 */
export type GetFlatgrammCompanyRelationCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: GetFlatgrammCompanyRelationCountResponseErrorDto
  /**
   * Всего связей квартирограмм и компаний
   */
  readonly data: number
}>
/**
 * Ошибка
 */
export type GetFlatgrammCompanyRelationCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetFlatgrammCompanyRelationCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения списка
 */
export type GetFlatgrammCompanyRelationListRequestDto = {
  /**
   * Фильтр связей квартирограмм и компаний
   */
  filter?: FlatgrammCompanyRelationFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: FlatgrammCompanyRelationPagingRequestDto
}>
/**
 * Ответ на запрос получения списка связей квартирограмм и компаний
 */
export type GetFlatgrammCompanyRelationListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: GetFlatgrammCompanyRelationListResponseErrorDto
  /**
   * Связь квартирограммы и компании
   */
  readonly data: FlatgrammCompanyRelationResponseDto
}>
/**
 * Ошибка
 */
export type GetFlatgrammCompanyRelationListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetFlatgrammCompanyRelationListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения количества упрощенных квартирограмм
 */
export type GetFlatgrammCountRequestDto = {
  /**
   * Фильтр
   */
  filter?: FlatgrammFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества упрощенных квартирограмм
 */
export type GetFlatgrammCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего упрощенных квартирограмм
   */
  readonly data: number
}>
/**
 * Запрос получения количества связей квартирограмм и домофонной компании
 * @deprecated
 */
export type GetFlatgrammDcCompanyCountRequestDto = {
  /**
   * Фильтр связей квартирограмм и домофонной компании
   */
  filter?: DcCompanyFlatgrammFilterRequestDto | null
}
/**
 * Ответ на запрос получения количества связей квартирограмм и домофонной компании
 * @deprecated
 */
export type GetFlatgrammDcCompanyCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: GetFlatgrammDcCompanyCountResponseErrorDto
  /**
   * Всего связей квартирограмм и домофонной компании
   */
  readonly data: number
}>
/**
 * Ошибка
 */
export type GetFlatgrammDcCompanyCountResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetFlatgrammDcCompanyCountResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения списка
 * @deprecated
 */
export type GetFlatgrammDcCompanyListRequestDto = {
  /**
   * Фильтр связей квартирограмм и домофонной компании
   */
  filter?: DcCompanyFlatgrammFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Пагинация
   */
  readonly paging: DcCompanyFlatgrammPagingRequestDto
}>
/**
 * Ответ на запрос получения списка связей квартирограмм и домофонной компании
 * @deprecated
 */
export type GetFlatgrammDcCompanyListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: GetFlatgrammDcCompanyListResponseErrorDto
  /**
   * Связь квартирограммы и домофонной компании
   */
  readonly data: DcCompanyFlatgrammResponseDto
}>
/**
 * Ошибка
 */
export type GetFlatgrammDcCompanyListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка
 */
export type GetFlatgrammDcCompanyListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение списка упрощенных квартирограмм
 */
export type GetFlatgrammListRequestDto = {
  /**
   * Фильтр
   */
  filter?: FlatgrammFilterRequestDto | null
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Стандартный постраничный вывод
   */
  readonly paging: FlatgrammPagingRequestDto
}>
/**
 * Ответ на запрос на получение списка упрощенных квартирограмм
 */
export type GetFlatgrammListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Упрощенная квартирограмма
   */
  readonly data: FlatgrammResponseDto
  /**
   * Ошибка
   */
  readonly error: GetFlatgrammListResponseErrorDto
}>
/**
 * Ошибка запроса получения списка упрощенных квартирограмм
 */
export type GetFlatgrammListResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка упрощенных квартирограмм
 */
export type GetFlatgrammListResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос на получение упрощенной квартирограммы
 */
export type GetFlatgrammRequestDto = {
  /**
   * Идентификатор
   */
  id: number
}
/**
 * Ответ на запрос на получение упрощенной квартирограммы
 */
export type GetFlatgrammResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Упрощенная квартирограмма
   */
  readonly data: FlatgrammResponseDto
  /**
   * Ошибка
   */
  readonly error: GetFlatgrammResponseErrorDto
}>
/**
 * Ошибка запроса получения списка упрощенных квартирограмм
 */
export type GetFlatgrammResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса получения списка упрощенных квартирограмм
 */
export type GetFlatgrammResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос сохранения связей квартирограммы и компании
 */
export type PutFlatgrammCompanyRelationAttachRequestDto = {
  /**
   * Связь квартирограммы и компании
   */
  flatgrammCompanyRelation: FlatgrammCompanyRelationRequestDto
}
/**
 * Ответ на запрос сохранения связи квартирограммы и компании
 */
export type PutFlatgrammCompanyRelationAttachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutFlatgrammCompanyRelationAttachResponseErrorDto
}>
/**
 * Ошибка запроса сохранения связи квартирограммы и компании
 */
export type PutFlatgrammCompanyRelationAttachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса сохранения связи квартирограммы и компании
 */
export type PutFlatgrammCompanyRelationAttachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос удаления связей квартирограммы и компании
 */
export type PutFlatgrammCompanyRelationDetachRequestDto = {
  /**
   * Связь квартирограммы и компании
   */
  flatgrammCompanyRelation: FlatgrammCompanyRelationRequestDto
}
/**
 * Ответ на запрос удаления связи квартирограммы и компании
 */
export type PutFlatgrammCompanyRelationDetachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutFlatgrammCompanyRelationDetachResponseErrorDto
}>
/**
 * Ошибка запроса удаления связи квартирограммы и компании
 */
export type PutFlatgrammCompanyRelationDetachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса удаления связи квартирограммы и компании
 */
export type PutFlatgrammCompanyRelationDetachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос сохранения связей квартирограммы и домофонной компании
 * @deprecated
 */
export type PutFlatgrammDcCompanyAttachRequestDto = {
  /**
   * Связь квартирограммы и домофонной компании
   */
  dcCompanyFlatgramm: DcCompanyFlatgrammRequestDto
}
/**
 * Ответ на запрос сохранения связи квартирограммы и домофонной компании
 * @deprecated
 */
export type PutFlatgrammDcCompanyAttachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutFlatgrammDcCompanyAttachResponseErrorDto
}>
/**
 * Ошибка запроса сохранения связи квартирограммы и домофонной компании
 */
export type PutFlatgrammDcCompanyAttachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса сохранения связи квартирограммы и домофонной компании
 */
export type PutFlatgrammDcCompanyAttachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Запрос удаления связей квартирограммы и домофонной компании
 * @deprecated
 */
export type PutFlatgrammDcCompanyDetachRequestDto = {
  /**
   * Связь квартирограммы и домофонной компании
   */
  dcCompanyFlatgramm: DcCompanyFlatgrammRequestDto
}
/**
 * Ответ на запрос удаления связи квартирограммы и домофонной компании
 * @deprecated
 */
export type PutFlatgrammDcCompanyDetachResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: PutFlatgrammDcCompanyDetachResponseErrorDto
}>
/**
 * Ошибка запроса удаления связи квартирограммы и домофонной компании
 */
export type PutFlatgrammDcCompanyDetachResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса удаления связи квартирограммы и домофонной компании
 */
export type PutFlatgrammDcCompanyDetachResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: controlAccessControlV1.ValidationErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Связка квартирограммы и домофонной компании.
   * Задает область ресурсов (resource scope), доступную пользователю.
   * Используется для контроля доступа к квартирограмме
   * @deprecated
   */
  "DcCompanyFlatgramm": {
    "kind": "class",
    "text": "Связка квартирограммы и домофонной компании.\nЗадает область ресурсов (resource scope), доступную пользователю.\nИспользуется для контроля доступа к квартирограмме",
    "fields": {
      /**
       * Идентификатор домофонной компании.
       * # Диапазон: 0..2147483647
       */
      "companyId": {
        "type": "int32",
        "text": "Идентификатор домофонной компании.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Идентификатор квартирограммы.
       * # Диапазон: 0..2147483647
       */
      "flatgrammId": {
        "type": "int32",
        "text": "Идентификатор квартирограммы.\n# Диапазон: 0..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Фильтр для запроса связей квартирограммы и домофонной компании.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   * @deprecated
   */
  "DcCompanyFlatgrammFilter": {
    "kind": "class",
    "text": "Фильтр для запроса связей квартирограммы и домофонной компании.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По Идентификатору домофонной компании
       */
      "companyIds": {
        "type": "int32",
        "text": "По Идентификатору домофонной компании",
      },
      /**
       * По Идентификатору квартирограммы
       */
      "flatgrammIds": {
        "type": "int32",
        "text": "По Идентификатору квартирограммы",
      },
    },
  },
  /**
   * Пагинация квартирограмм и домофонной компании
   * @deprecated
   */
  "DcCompanyFlatgrammPaging": {
    "kind": "class",
    "text": "Пагинация квартирограмм и домофонной компании",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: COMPANY_ID
       */
      "orderByType": {
        "type": "DcCompanyFlatgrammPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: COMPANY_ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "DcCompanyFlatgrammPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Облегченная квартирограмма
   */
  "Flatgramm": {
    "kind": "class",
    "text": "Облегченная квартирограмма",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
      },
      /**
       * Наименование
       */
      "title": {
        "type": "string",
        "text": "Наименование",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Идентификатор компании - владельца
       */
      "companyId": {
        "type": "int32",
        "text": "Идентификатор компании - владельца",
      },
      /**
       * Дата и время создания.
       * # Тип: DateTime
       */
      "createdAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата и время создания.\n# Тип: DateTime",
      },
      /**
       * Дата последнего изменения.
       * Заполняется и обновляется сервером.
       * Заполняется при создании и изменении.
       * Является версией объекта.
       * # Тип: DateTime
       */
      "changedAt": {
        "type": "google.protobuf.Timestamp",
        "text": "Дата последнего изменения.\nЗаполняется и обновляется сервером.\nЗаполняется при создании и изменении.\nЯвляется версией объекта.\n# Тип: DateTime",
      },
    },
  },
  /**
   * Связка квартирограммы и компании.
   * Задает область ресурсов (resource scope), доступную пользователю.
   * Используется для контроля доступа к квартирограмме
   */
  "FlatgrammCompanyRelation": {
    "kind": "class",
    "text": "Связка квартирограммы и компании.\nЗадает область ресурсов (resource scope), доступную пользователю.\nИспользуется для контроля доступа к квартирограмме",
    "fields": {
      /**
       * Идентификатор компании.
       * # Диапазон: 1..2147483647
       */
      "companyId": {
        "type": "int32",
        "text": "Идентификатор компании.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Идентификатор квартирограммы.
       * # Диапазон: 1..2147483647
       */
      "flatgrammId": {
        "type": "int32",
        "text": "Идентификатор квартирограммы.\n# Диапазон: 1..2147483647",
        "rules": {
          "required": "Значение обязательно для заполнения",
          "min": {
            "value": 1,
            "message": "Значение не входит в допустимый диапазон. Минимум: 1"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
      /**
       * Тип связи компании и квартирограммы
       */
      "type": {
        "type": "FlatgrammCompanyRelation.Type",
        "text": "Тип связи компании и квартирограммы",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Фильтр для запроса связей квартирограммы и компании.
   * При передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.
   * При передаче нескольких разных параметров фильтра они работают в выборке через И
   */
  "FlatgrammCompanyRelationFilter": {
    "kind": "class",
    "text": "Фильтр для запроса связей квартирограммы и компании.\nПри передаче массива в параметр фильтра элементы массива работают в выборке через ИЛИ.\nПри передаче нескольких разных параметров фильтра они работают в выборке через И",
    "fields": {
      /**
       * По Идентификатору квартирограммы
       */
      "flatgrammIds": {
        "type": "int32",
        "text": "По Идентификатору квартирограммы",
      },
      /**
       * По Идентификатору компании
       */
      "companyIds": {
        "type": "int32",
        "text": "По Идентификатору компании",
      },
      /**
       * Тип назначения компании для квартирограммы
       */
      "flatgrammCompanyRelationTypes": {
        "type": "FlatgrammCompanyRelation.Type",
        "text": "Тип назначения компании для квартирограммы",
      },
    },
  },
  /**
   * Пагинация квартирограмм и компаний
   */
  "FlatgrammCompanyRelationPaging": {
    "kind": "class",
    "text": "Пагинация квартирограмм и компаний",
    "fields": {
      /**
       * Тип значения сортировки.
       * По умолчанию: COMPANY_ID
       */
      "orderByType": {
        "type": "FlatgrammCompanyRelationPaging.OrderByType",
        "text": "Тип значения сортировки.\nПо умолчанию: COMPANY_ID",
      },
      /**
       * Тип направления сортировки.
       * По умолчанию: DESC
       */
      "directionType": {
        "type": "FlatgrammCompanyRelationPaging.DirectionType",
        "text": "Тип направления сортировки.\nПо умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Минимальное значение: 1.
       * Максимальное значение: 100.
       * По умолчанию: 20.
       * Если значение 0 (не передано), то выставляем значение по умолчанию
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nМинимальное значение: 1.\nМаксимальное значение: 100.\nПо умолчанию: 20.\nЕсли значение 0 (не передано), то выставляем значение по умолчанию",
      },
      /**
       * Сдвиг.
       * По умолчанию: 0
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\nПо умолчанию: 0",
      },
    },
  },
  /**
   * Фильтр квартирограмм
   */
  "FlatgrammFilter": {
    "kind": "class",
    "text": "Фильтр квартирограмм",
    "fields": {
      /**
       * По идентификаторам компаний.
       * Фильтрация среди компаний, тип связи компании и КВГ определяется по полю company_relation_types.
       * Если company_relation_types не передан, то учитываются все значения типа FlatgrammCompanyRelation.Type
       */
      "companyIds": {
        "type": "int32",
        "text": "По идентификаторам компаний.\nФильтрация среди компаний, тип связи компании и КВГ определяется по полю company_relation_types.\nЕсли company_relation_types не передан, то учитываются все значения типа FlatgrammCompanyRelation.Type",
      },
      /**
       * Поиск по тексту.
       * Если значение не передано то поиск по нему не производится.
       * # Диапазон: 3..64.
       * # Поиск производится по полям:
       * # - Наименование
       */
      "text": {
        "type": "string",
        "text": "Поиск по тексту.\nЕсли значение не передано то поиск по нему не производится.\n# Диапазон: 3..64.\n# Поиск производится по полям:\n# - Наименование",
        "rules": {
          "minLength": {
            "value": 3,
            "message": "Значение не входит в допустимый диапазон. Минимум: 3"
          },
          "maxLength": {
            "value": 64,
            "message": "Значение не входит в допустимый диапазон. Максимум: 64"
          },
        }
      },
      /**
       * По идентификаторам компаний.
       * Фильтрация среди компаний, привязанных как домофонные компании
       * @deprecated
       */
      "dcCompanyIds": {
        "type": "int32",
        "text": "По идентификаторам компаний.\nФильтрация среди компаний, привязанных как домофонные компании",
      },
      /**
       * По типу связи квартирограмм и компаний
       */
      "flatgrammCompanyRelationTypes": {
        "type": "FlatgrammCompanyRelation.Type",
        "text": "По типу связи квартирограмм и компаний",
      },
    },
  },
  /**
   * Постраничный вывод
   */
  "FlatgrammPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Тип значения сортировки.
       * Если значение не передано, то будет взято значение по умолчанию.
       * # По умолчанию: CHANGED_AT
       */
      "orderByType": {
        "type": "FlatgrammPaging.OrderByType",
        "text": "Тип значения сортировки.\nЕсли значение не передано, то будет взято значение по умолчанию.\n# По умолчанию: CHANGED_AT",
      },
      /**
       * Тип направления сортировки.
       * # По умолчанию: DESC
       */
      "directionType": {
        "type": "FlatgrammPaging.DirectionType",
        "text": "Тип направления сортировки.\n# По умолчанию: DESC",
      },
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос получения количества связей квартирограмм и компаний
   */
  "GetFlatgrammCompanyRelationCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества связей квартирограмм и компаний",
    "fields": {
      /**
       * Фильтр связей квартирограмм и компании
       */
      "filter": {
        "type": "FlatgrammCompanyRelationFilter",
        "text": "Фильтр связей квартирограмм и компании",
      },
    },
  },
  /**
   * Ответ на запрос получения количества связей квартирограмм и компаний
   */
  "GetFlatgrammCompanyRelationCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества связей квартирограмм и компаний",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "GetFlatgrammCompanyRelationCountResponse.Error",
        "text": "Ошибка",
      },
      /**
       * Всего связей квартирограмм и компаний
       */
      "data": {
        "type": "int32",
        "text": "Всего связей квартирограмм и компаний",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetFlatgrammCompanyRelationCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка
   */
  "GetFlatgrammCompanyRelationListRequest": {
    "kind": "class",
    "text": "Запрос получения списка",
    "fields": {
      /**
       * Фильтр связей квартирограмм и компаний
       */
      "filter": {
        "type": "FlatgrammCompanyRelationFilter",
        "text": "Фильтр связей квартирограмм и компаний",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "FlatgrammCompanyRelationPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка связей квартирограмм и компаний
   */
  "GetFlatgrammCompanyRelationListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка связей квартирограмм и компаний",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "GetFlatgrammCompanyRelationListResponse.Error",
        "text": "Ошибка",
      },
      /**
       * Связь квартирограммы и компании
       */
      "data": {
        "type": "FlatgrammCompanyRelation",
        "text": "Связь квартирограммы и компании",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetFlatgrammCompanyRelationListResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества упрощенных квартирограмм
   */
  "GetFlatgrammCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества упрощенных квартирограмм",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "FlatgrammFilter",
        "text": "Фильтр",
      },
    },
  },
  /**
   * Ответ на запрос получения количества упрощенных квартирограмм
   */
  "GetFlatgrammCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества упрощенных квартирограмм",
    "fields": {
      /**
       * Всего упрощенных квартирограмм
       */
      "data": {
        "type": "int32",
        "text": "Всего упрощенных квартирограмм",
      },
    },
  },
  /**
   * Запрос получения количества связей квартирограмм и домофонной компании
   * @deprecated
   */
  "GetFlatgrammDcCompanyCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества связей квартирограмм и домофонной компании",
    "fields": {
      /**
       * Фильтр связей квартирограмм и домофонной компании
       */
      "filter": {
        "type": "DcCompanyFlatgrammFilter",
        "text": "Фильтр связей квартирограмм и домофонной компании",
      },
    },
  },
  /**
   * Ответ на запрос получения количества связей квартирограмм и домофонной компании
   * @deprecated
   */
  "GetFlatgrammDcCompanyCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества связей квартирограмм и домофонной компании",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "GetFlatgrammDcCompanyCountResponse.Error",
        "text": "Ошибка",
      },
      /**
       * Всего связей квартирограмм и домофонной компании
       */
      "data": {
        "type": "int32",
        "text": "Всего связей квартирограмм и домофонной компании",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetFlatgrammDcCompanyCountResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения списка
   * @deprecated
   */
  "GetFlatgrammDcCompanyListRequest": {
    "kind": "class",
    "text": "Запрос получения списка",
    "fields": {
      /**
       * Фильтр связей квартирограмм и домофонной компании
       */
      "filter": {
        "type": "DcCompanyFlatgrammFilter",
        "text": "Фильтр связей квартирограмм и домофонной компании",
      },
      /**
       * Пагинация
       */
      "paging": {
        "type": "DcCompanyFlatgrammPaging",
        "text": "Пагинация",
      },
    },
  },
  /**
   * Ответ на запрос получения списка связей квартирограмм и домофонной компании
   * @deprecated
   */
  "GetFlatgrammDcCompanyListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка связей квартирограмм и домофонной компании",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "GetFlatgrammDcCompanyListResponse.Error",
        "text": "Ошибка",
      },
      /**
       * Связь квартирограммы и домофонной компании
       */
      "data": {
        "type": "DcCompanyFlatgramm",
        "text": "Связь квартирограммы и домофонной компании",
      },
    },
  },
  /**
   * Ошибка
   */
  "GetFlatgrammDcCompanyListResponse.Error": {
    "kind": "class",
    "text": "Ошибка",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение списка упрощенных квартирограмм
   */
  "GetFlatgrammListRequest": {
    "kind": "class",
    "text": "Запрос на получение списка упрощенных квартирограмм",
    "fields": {
      /**
       * Фильтр
       */
      "filter": {
        "type": "FlatgrammFilter",
        "text": "Фильтр",
      },
      /**
       * Стандартный постраничный вывод
       */
      "paging": {
        "type": "FlatgrammPaging",
        "text": "Стандартный постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос на получение списка упрощенных квартирограмм
   */
  "GetFlatgrammListResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение списка упрощенных квартирограмм",
    "fields": {
      /**
       * Упрощенная квартирограмма
       */
      "data": {
        "type": "Flatgramm",
        "text": "Упрощенная квартирограмма",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetFlatgrammListResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка упрощенных квартирограмм
   */
  "GetFlatgrammListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка упрощенных квартирограмм",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос на получение упрощенной квартирограммы
   */
  "GetFlatgrammRequest": {
    "kind": "class",
    "text": "Запрос на получение упрощенной квартирограммы",
    "fields": {
      /**
       * Идентификатор
       */
      "id": {
        "type": "int32",
        "text": "Идентификатор",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на получение упрощенной квартирограммы
   */
  "GetFlatgrammResponse": {
    "kind": "class",
    "text": "Ответ на запрос на получение упрощенной квартирограммы",
    "fields": {
      /**
       * Упрощенная квартирограмма
       */
      "data": {
        "type": "Flatgramm",
        "text": "Упрощенная квартирограмма",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "GetFlatgrammResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса получения списка упрощенных квартирограмм
   */
  "GetFlatgrammResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса получения списка упрощенных квартирограмм",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос сохранения связей квартирограммы и компании
   */
  "PutFlatgrammCompanyRelationAttachRequest": {
    "kind": "class",
    "text": "Запрос сохранения связей квартирограммы и компании",
    "fields": {
      /**
       * Связь квартирограммы и компании
       */
      "flatgrammCompanyRelation": {
        "type": "FlatgrammCompanyRelation",
        "text": "Связь квартирограммы и компании",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения связи квартирограммы и компании
   */
  "PutFlatgrammCompanyRelationAttachResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения связи квартирограммы и компании",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutFlatgrammCompanyRelationAttachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения связи квартирограммы и компании
   */
  "PutFlatgrammCompanyRelationAttachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения связи квартирограммы и компании",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос удаления связей квартирограммы и компании
   */
  "PutFlatgrammCompanyRelationDetachRequest": {
    "kind": "class",
    "text": "Запрос удаления связей квартирограммы и компании",
    "fields": {
      /**
       * Связь квартирограммы и компании
       */
      "flatgrammCompanyRelation": {
        "type": "FlatgrammCompanyRelation",
        "text": "Связь квартирограммы и компании",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления связи квартирограммы и компании
   */
  "PutFlatgrammCompanyRelationDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления связи квартирограммы и компании",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutFlatgrammCompanyRelationDetachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса удаления связи квартирограммы и компании
   */
  "PutFlatgrammCompanyRelationDetachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса удаления связи квартирограммы и компании",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос сохранения связей квартирограммы и домофонной компании
   * @deprecated
   */
  "PutFlatgrammDcCompanyAttachRequest": {
    "kind": "class",
    "text": "Запрос сохранения связей квартирограммы и домофонной компании",
    "fields": {
      /**
       * Связь квартирограммы и домофонной компании
       */
      "dcCompanyFlatgramm": {
        "type": "DcCompanyFlatgramm",
        "text": "Связь квартирограммы и домофонной компании",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос сохранения связи квартирограммы и домофонной компании
   * @deprecated
   */
  "PutFlatgrammDcCompanyAttachResponse": {
    "kind": "class",
    "text": "Ответ на запрос сохранения связи квартирограммы и домофонной компании",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutFlatgrammDcCompanyAttachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса сохранения связи квартирограммы и домофонной компании
   */
  "PutFlatgrammDcCompanyAttachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса сохранения связи квартирограммы и домофонной компании",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос удаления связей квартирограммы и домофонной компании
   * @deprecated
   */
  "PutFlatgrammDcCompanyDetachRequest": {
    "kind": "class",
    "text": "Запрос удаления связей квартирограммы и домофонной компании",
    "fields": {
      /**
       * Связь квартирограммы и домофонной компании
       */
      "dcCompanyFlatgramm": {
        "type": "DcCompanyFlatgramm",
        "text": "Связь квартирограммы и домофонной компании",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления связи квартирограммы и домофонной компании
   * @deprecated
   */
  "PutFlatgrammDcCompanyDetachResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления связи квартирограммы и домофонной компании",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "PutFlatgrammDcCompanyDetachResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса удаления связи квартирограммы и домофонной компании
   */
  "PutFlatgrammDcCompanyDetachResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса удаления связи квартирограммы и домофонной компании",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "DcCompanyFlatgrammPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов сортировки
   */
  "DcCompanyFlatgrammPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По Идентификатору домофонной компании
       */
      "COMPANY_ID": {
        "i": 1,
        "text": "По Идентификатору домофонной компании",
      },
      /**
       * По Идентификатору квартирограммы
       */
      "FLATGRAMM_ID": {
        "i": 2,
        "text": "По Идентификатору квартирограммы",
      },
    },
  },
  /**
   * Тип связи компании и квартирограммы.
   * По умолчанию OWNER.
   */
  "FlatgrammCompanyRelation.Type": {
    "kind": "enum",
    "text": "Тип связи компании и квартирограммы.\nПо умолчанию OWNER.",
    "values": {
      /**
       * Значение не указано
       */
      "TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * Управляющая компания владеет квартирограммой
       */
      "MANAGEMENT": {
        "i": 1,
        "text": "Управляющая компания владеет квартирограммой",
      },
      /**
       * Домофонная компания обслуживает квартирограмму
       */
      "DEVICE_SERVICE": {
        "i": 2,
        "text": "Домофонная компания обслуживает квартирограмму",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки
   */
  "FlatgrammCompanyRelationPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов сортировки
   */
  "FlatgrammCompanyRelationPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов сортировки",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По Идентификатору компании
       */
      "COMPANY_ID": {
        "i": 1,
        "text": "По Идентификатору компании",
      },
      /**
       * По Идентификатору квартирограммы
       */
      "FLATGRAMM_ID": {
        "i": 2,
        "text": "По Идентификатору квартирограммы",
      },
    },
  },
  /**
   * Справочник типов направлений сортировки.
   */
  "FlatgrammPaging.DirectionType": {
    "kind": "enum",
    "text": "Справочник типов направлений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "DIRECTION_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * От большего к меньшему
       */
      "DESC": {
        "i": 1,
        "text": "От большего к меньшему",
      },
      /**
       * От меньшего к большему
       */
      "ASC": {
        "i": 2,
        "text": "От меньшего к большему",
      },
    },
  },
  /**
   * Справочник типов значений сортировки.
   */
  "FlatgrammPaging.OrderByType": {
    "kind": "enum",
    "text": "Справочник типов значений сортировки.",
    "values": {
      /**
       * Значение не указано
       */
      "ORDER_BY_TYPE_UNKNOWN": {
        "i": 0,
        "text": "Значение не указано",
      },
      /**
       * По идентификатору
       */
      "ID": {
        "i": 1,
        "text": "По идентификатору",
      },
      /**
       * По времени создания
       */
      "CREATED_AT": {
        "i": 2,
        "text": "По времени создания",
      },
      /**
       * По времени изменения
       */
      "CHANGED_AT": {
        "i": 3,
        "text": "По времени изменения",
      },
      /**
       * По рангу для поиска по тексту.
       * Применяется когда передано поле для поиска по тексту.
       * В случае если текстовое поле не передано, применяется значение по умолчанию
       */
      "RANK": {
        "i": 4,
        "text": "По рангу для поиска по тексту.\nПрименяется когда передано поле для поиска по тексту.\nВ случае если текстовое поле не передано, применяется значение по умолчанию",
      },
    },
  },
}